import { RentalHistory } from '../app/models/rentalhistory';
import { RentalHistoryInterface } from '../app/interface/rentalhistory';
import { ApplicationDataService } from './application.service'

import { environment } from '../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {map, catchError} from 'rxjs/operators';


@Injectable()
export class RentalHistoryDataService {
    public static _API_ENDPOINT = environment.apiEndPoint;

    constructor(private http: HttpClient, private applicationService: ApplicationDataService) { }

    getRentalHistory(RentalApplicantKey: string, AddAdditionalApplicantKey: string) {
        return this.http.get<RentalHistoryInterface[]>(RentalHistoryDataService._API_ENDPOINT + 'Application/GetRentalHistory?RentalApplicantKey='
        + RentalApplicantKey + '&AddAdditionalApplicantKey=' + AddAdditionalApplicantKey, this.applicationService.createOptions())
        .pipe(
            catchError(this.applicationService.handleError),
            map((response) => <RentalHistoryInterface[]>(response))
        );
    }

    updateRentalHistory(RentalApplicantKey: number, RentalApplicationKey: number, CompletedByOther: boolean, History: RentalHistory[]) {
        return this.http.post<RentalHistoryInterface[]>(RentalHistoryDataService._API_ENDPOINT + 'Application/UpdateRentalHistory?RentalApplicantKey=' +
        RentalApplicantKey + '&RentalApplicationKey=' + RentalApplicationKey + '&CompletedByOther=' + CompletedByOther, History, this.applicationService.createOptions())
        .pipe(
            catchError(this.applicationService.handleError),
            map((response) => <RentalHistoryInterface[]>(response))
        );
    }
}
